import React, { useState, useEffect } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import "./ScrollTopButton.css"
import { DotLottieReact } from '@lottiefiles/dotlottie-react';


const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show or hide the button based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Scroll the page to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  if (!isVisible) return null;

  return (
    <div
    onClick={scrollToTop}
    className="fixed bottom-5 right-1 z-50 cursor-pointer hover:scale-110 transition-transform"
    title="Go to top"
    >
     <DotLottieReact
      src="https://lottie.host/197273f5-32a1-4264-8489-8ef0b353c61f/EbZirTG3Qw.lottie"
      loop
      autoplay
      className='h-[60px]'
    />
    </div>
  );
};

export default ScrollToTopButton;
